__webpack_require__.p = "/campus/";